import { Box, CardActions, Collapse } from "@mui/material"
import { startOfDay } from "date-fns"
import { useState } from "react"
import { NexCard, NexCardActionButton, NexCardContent, NexCardTransitionGroup } from "../../components/NexCard"
import { Body, Subtitle2, Title } from "../../components/Typography/Typography"
import { useMissions } from "../../hooks/useMissions"
import { Sortie, getInitialSortie } from "../../models/Sortie"
import { MissionActiveFlow } from "../../store/types/MissionsTypes"
import { TimeUtilsDateFns } from "../../utils/TimeUtils"
import { SortieCard } from "./SortieCard"
import { SortieEditorDialog } from "./SortieEditorDialog"

export const SortieCardList = () => {
    const { missions, handleMissionDataChange } = useMissions()
    const { selectedMission, activeFlow, isVendorFlow } = missions
    const [editDialogSortie, setEditDialogSortie] = useState<Sortie>()
    const [isCreatedSortie, setIsCreatingSortie] = useState<boolean>(false)

    const sorties = selectedMission.sorties ?? []
    const sortieRequired = activeFlow !== MissionActiveFlow.NO_FLIGHT && !isVendorFlow

    const handleCloseDialog = (_?: object, reason?: string) => {
        if (reason && reason === "backdropClick") {
            return
        }
        setEditDialogSortie(undefined)
        setIsCreatingSortie(false)
    }

    const handleAddNewSortie = () => {
        const newSorties = selectedMission.sorties.slice()

        /**
         * if there is a sortie already, use the previous sortie's stop time
         * else use the mission's flown date
         */
        let flownDateToUse: Date
        if (newSorties.length) {
            flownDateToUse = startOfDay(newSorties[newSorties.length - 1].fe_stop_sortie)
        } else if (selectedMission.flown_date) {
            flownDateToUse = TimeUtilsDateFns.getDateFromFormattedDay(selectedMission.flown_date)
        } else {
            flownDateToUse = startOfDay(new Date())
        }

        const newEntry: Sortie = { ...getInitialSortie(flownDateToUse), frontend_id: newSorties.length + 1 }
        newSorties.push(newEntry)

        handleMissionDataChange({ sorties: newSorties })
        setEditDialogSortie(newEntry)
        setIsCreatingSortie(true)
    }

    return (
        <Box>
            {/* Sorties*/}
            <NexCardTransitionGroup>
                {sorties.map((sortie, index) => {
                    return (
                        <Collapse key={sortie.frontend_id} sx={{ pr: 2, boxSizing: "border-box" }}>
                            <SortieCard
                                required={sortieRequired}
                                sortie={sortie}
                                sortieNumber={index + 1}
                                setEditDialogSortie={setEditDialogSortie}
                            />
                        </Collapse>
                    )
                })}
                <Collapse>
                    <NexCard>
                        <NexCardContent sx={{ height: "auto" }}>
                            <Title disableGutter={true}>Add Flight Details</Title>
                            {sortieRequired && sorties.length === 0 && (
                                <Subtitle2 disableGutter={true}>Required</Subtitle2>
                            )}
                            <Body sx={{ pt: 2 }}>
                                Complete your mission log by including every sortie from your acquisition mission
                            </Body>
                        </NexCardContent>
                        <CardActions sx={{ display: "flex", justifyContent: "right" }}>
                            <NexCardActionButton onClick={handleAddNewSortie}>Add Sortie</NexCardActionButton>
                        </CardActions>
                    </NexCard>
                </Collapse>
            </NexCardTransitionGroup>

            {/* Dialog Editor */}
            {!!editDialogSortie && (
                <SortieEditorDialog
                    isEditDialogOpen={!!editDialogSortie}
                    setCloseDialog={handleCloseDialog}
                    sortie={editDialogSortie}
                    isCreatingSortie={isCreatedSortie}
                />
            )}
        </Box>
    )
}
